module.exports = __webpack_public_path__ + "img/vtec.b864ce3f.png";